import ReactModal from "react-modal";
import styled from "styled-components";

/**
 * 공용 모달 셸 (react-modal 래퍼).
 *
 * 회원·관리자 등 폼 모달들이 각자 따로 정의하던 styled(modal) 흰 박스와
 * 동일한 반투명 오버레이(rgba(0,0,0,0.5))를 통일한 것. 박스 크기만 width/height로 받는다.
 * 앱 전역 appElement(#root)는 GlobalAlertProvider에서 한 번만 설정한다.
 */
const OVERLAY_STYLE = { overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" } };

const Box = styled(ReactModal)`
  display: flex;
  flex-direction: column;
  width: ${({ $width }) => $width}px;
  height: ${({ $height }) => $height}px;
  border-radius: 3px;
  background-color: #fff;
  margin: 15vh auto;
  padding: 40px 50px;
`;

export function ModalShell({
  isOpen,
  onRequestClose,
  width = 620,
  height = 552,
  children,
  ...rest
}) {
  return (
    <Box
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      $width={width}
      $height={height}
      style={OVERLAY_STYLE}
      {...rest}
    >
      {children}
    </Box>
  );
}

export default ModalShell;
